(function() {
	'use strict';

	var overlayPopup = avm.require('avast.web.overlayPopup');
	overlayPopup(); // init function

})();
